module.exports = __webpack_public_path__ + "b08620b37d2f4e306b5f687e63b0a8ab.svg";